import { action, extendObservable } from 'mobx';
import orderBy from 'lodash/orderBy';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class PlacementTestRulerListService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      rulers: [],
    });
  }

  init = action(() => {
    this.rulers = [];
    this.load();
  });

  load = action(() => {
    this.fetch.fetch({
      url: '/placement-test-rulers',
      apiVersion: 'v3'
    }).then(() => {
      if (this.fetch.data) {
        this.rulers = orderBy(this.fetch.data, 'name');
      } else {
        this.rulers = [];
      }
    });
  });

  handleRemove = action((PlacementTestRuler) => {
    ConfirmationDialogService.show(
      'Delete Placement Test Level',
      `You are about to delete the Placement Test Ruler "${PlacementTestRuler.level}", Do you want to continue ?`,
      () => {
        this.fetch.fetch({
          url: `/placement-test-rulers/${PlacementTestRuler.id}`,
          apiVersion: 'v3',
          method: 'delete',
        }).then(() => {
          NotificationService.addNotification(`Placement Test Ruler "${PlacementTestRuler.name}" deleted successfully.`, 'success');
          this.load();
        });
      });
  });
}

const placementTestRulerListService = new PlacementTestRulerListService()

export default placementTestRulerListService;
